import { Auth } from "aws-amplify";
import axios from "axios";
// import * as qs from "qs";

const ACS_API_BASE_URL = process.env.MAIN_API;

// console.log("PRINT", BI_API_BASE_URL);

class DataInterfaceService {

  async getAF2DataProcessingRecords() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(ACS_API_BASE_URL + "/management/get_af2_data", myInit);
  }

  async postAutoProcessing(profile) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.post(
      ACS_API_BASE_URL + "/management/update_data_interface",
      profile,
      myInit
    );
  }
}

export default new DataInterfaceService();
